import { buildQuery } from '@calendly/http-tools'
import { CalendarAddIcon, AddUserIcon } from '@calendly/ui/components/icons'

import { CONTENT_PAGES } from 'features/empty_state'
import { newFormUrl } from 'features/routing'

import {
  EVENT_TYPES_PATH,
  ADMIN_INVITE_PATH
} from '../constants'

const placeholderOptions = () => ({
  onClick: () => { alert('Placeholder') },
})

const analyticsEventsOptions = ({ history }) => ({
  onClick: () => { history.push(EVENT_TYPES_PATH) },
})

const analyticsMeetingsOptions = ({ history }) => ({
  onClick: () => { history.push(EVENT_TYPES_PATH) },
})

const adminDashboardOptions = ({ history }) => ({
  onClick: () => { history.push(ADMIN_INVITE_PATH) },
  icon: <AddUserIcon />
})

const analyticsRoutingOptions = ({ history }) => ({
  onClick: () => { history.push(newFormUrl('type')) },
})

const contactsOptions = ({ history }) => ({
  onClick: () => { history.push(EVENT_TYPES_PATH) },
})

const meetingsOptions = ({ history, options }) => ({
  onClick: () => { history.push(options.url) },
  icon: <CalendarAddIcon />
})

const meetingTypesOptions = () => ({
})

const pollsOptions = ({ history }) => {
  const searchStr = buildQuery({ create_new_meeting: 'poll' }, { addQueryPrefix: true })

  return { onClick: () => { history.push({ search: searchStr }) } }
}

const routingFormsOptions = ({ history }) => ({
  onClick: () => { history.push(newFormUrl('type')) },
})

const eventTypesOptions = () => ({
})

const managedEventTypesOptions = ({ history, options }) => ({
  onClick: () => { history.push(options.url) }
})

const usersOptions = ({ history }) => ({
  onClick: () => { history.push(ADMIN_INVITE_PATH) },
})

const groupsOptions = ({ options }) => ({
  onClick: options.onClick
})

const OPTIONS_BY_FEATURE_KEY = {
  [CONTENT_PAGES.adminDashboard]: adminDashboardOptions,
  [CONTENT_PAGES.analyticsEvents]: analyticsEventsOptions,
  [CONTENT_PAGES.analyticsMeetings]: analyticsMeetingsOptions,
  [CONTENT_PAGES.analyticsRouting]: analyticsRoutingOptions,
  [CONTENT_PAGES.contacts]: contactsOptions,
  [CONTENT_PAGES.eventTypes]: eventTypesOptions,
  [CONTENT_PAGES.groups]: groupsOptions,
  [CONTENT_PAGES.managedEventTypes]: managedEventTypesOptions,
  [CONTENT_PAGES.managedWorkflows]: placeholderOptions,
  [CONTENT_PAGES.meetings]: meetingsOptions,
  [CONTENT_PAGES.meetingTypes]: meetingTypesOptions,
  [CONTENT_PAGES.routingForms]: routingFormsOptions,
  [CONTENT_PAGES.users]: usersOptions,
  [CONTENT_PAGES.workflows]: placeholderOptions,
  [CONTENT_PAGES.singleUseLinks]: placeholderOptions,
  [CONTENT_PAGES.polls]: pollsOptions,
  [CONTENT_PAGES.recaps]: meetingsOptions,
  [CONTENT_PAGES.recapsMIEnabled]: meetingsOptions,
}

export const getPrimaryButtonOptionsByContentKey = (contentKey, buttonParams) => (OPTIONS_BY_FEATURE_KEY[contentKey]
  ? OPTIONS_BY_FEATURE_KEY[contentKey](buttonParams)
  : placeholderOptions)
